import Vue from 'vue/dist/vue.esm';

// Axios defaults
import axios from 'axios';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common.Accept = 'application/json';

import validate from './config/validate.js';

import './styles/tailwind.css';
import './styles/pintura.scss';
import { initSentry } from '../shared/sentry_config';

// Initialize Sentry
initSentry(Vue);

import PromoGenerator from './promo-generator.vue';

document.addEventListener('DOMContentLoaded', () => {
  // Setup the axios and vee-validate rules
  validate();

  const app = new Vue({
    el: '#promo-generator',
    components: {
      PromoGenerator
    },
  });
});
